"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MetricIcon = function (props) { return (
// tslint:disable:max-line-length
React.createElement("svg", __assign({ id: 'MetricIcon__Layer_1', x: 0, y: 0, width: 18, height: 18, xmlSpace: 'preserve', role: 'img' }, props),
    React.createElement("style", null, '.prefix__st0{fill:#333}'),
    React.createElement("g", null,
        React.createElement("g", null,
            React.createElement("path", { id: 'Square_3_', d: 'M14,3H3C2.5,3,2,3.5,2,4v11c0,0.5,0.5,1,1,1h11c0.5,0,1-0.5,1-1V4C15,3.5,14.5,3,14,3z M14,15    H3V4h11V15z' })),
        React.createElement("polygon", { points: '9.3,11.7 6.8,9.2 4.9,11.5 4.1,10.9 6.7,7.8 9.2,10.2 12.1,7.1 12.9,7.8  ' })))
// tslint:enable:max-line-length
); };
exports.MetricIcon = MetricIcon;
//# sourceMappingURL=MetricIcon.js.map